import video from './../assets/bgVideo.mp4';
type Props = {}

function BgVideo({ }: Props) {
    return (
        <div className="relative w-screen overflow-hiddenh-auto">
           <video src={video} autoPlay muted className="w-full h-[850px] xl:h-[900px] object-cover" />
           <div className='absolute inset-0 flex flex-col items-center justify-center text-center z-20'>
                <span className='text-white font-bold text-2xl md:text-4xl xl:text-5xl'>Uncover actionable insights</span>
                <span className='text-white font-bold text-2xl md:text-4xl xl:text-5xl'>from your sponsored events</span>
                <span className='text-white font-regular text-lg md:text-xl xl:text-xl mt-4 xl:mt-8 mb-6'>Measure, analyze and optimize every experiential event.</span>
                <button className="bg-neonGreen py-2.5 px-3.5 rounded-md w-28 mt-4 font-bold text-base text-black">
                    Try it out
                </button>
            </div>
        </div>
    )
}

export default BgVideo